<div class="em-c-modal " role="alertdialog" aria-modal="true" aria-labelledby="modalTitle"
  aria-describedby="modalDescription">
  <section class="em-c-modal__window">
    <div class="em-c-modal__header " tabindex="0">
      <div class="em-c-modal__title" id="modalTitle">
        Select the Experiment to Generate Report
      </div>
      <button [mat-dialog-close]="true" class="em-c-btn em-c-btn--bare     em-c-modal__close-btn" title="Close modal"
        aria-label="Button name">
        <div class="em-c-btn__inner">
          <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#x-filled"></use>
          </svg>
        </div>
      </button>
    </div>
    <div class="em-c-modal__body overflow-auto" id="modalDescription">
      <div class="">
        <div class="mat-mdc-table">
          @for (labTest of data.groupedData; track $index) {
          <ng-container>
            <div class="fields-container">
              <div class="field">
                <span>Sample Name: &ensp;<b class="textDesign">{{labTest.cylinder}}</b></span>
              </div>
              <div class="field">
                <span>Well Name: &ensp;<b class="textDesign">{{labTest.wellName}}</b></span>
              </div>
              <div class="field">
              
                <a class="preview-link" role="button" tabindex="0" (click)="SelectedExperiments(true)"
                  (keydown.enter)="SelectedExperiments(true)" (keydown.space)="SelectedExperiments(true)">
                  Preview Report
                </a>
              
              </div>
            </div>
            <table class="em-c-table em-dc-table em-u-margin-bottom" role="table" mat-table
              [dataSource]="labTest.labTestRepeat" cdkDropList (cdkDropListDropped)="Drop($event)"
              [cdkDropListData]="labTest.labTestRepeat">

              <!-- SELECT column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="checkbox-color">
                  <mat-checkbox (change)="$event ? MasterToggle(labTest) : null" [checked]="IsAllSelected(labTest)"
                    [indeterminate]="GetSelection(labTest.labTestId).selected.length > 0 && !IsAllSelected(labTest)">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? ToggleRow(labTest, row) : null"
                    [checked]="GetSelection(labTest.labTestId).isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Experiment Name -->
              <ng-container matColumnDef="experimentName">
                <th mat-header-cell *matHeaderCellDef>Experiment Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.experimentName }}
                </td>
              </ng-container>

              <!-- Experiment Sequence -->
              <ng-container matColumnDef="experimentSequenceNo">
                <th mat-header-cell *matHeaderCellDef>Experiment Sequence</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.experimentSequenceNo }}
                </td>
              </ng-container>

              <!-- Header & Row defs -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="ToggleRow(labTest, row)" cdkDrag
                [cdkDragData]="row">
              </tr>
            </table>
          </ng-container>
          }
        </div>
        <div class="paginator">
          <mat-paginator #paginator [length]="dataSource.data.length" [pageSize]="pageEvent.pageSize"
            [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
    <div class="em-c-modal__footer">

      <div class="checkboxDiv">
        <mat-checkbox class="reportCheckbox" [(ngModel)]="pdfSelected"><span>PDF</span></mat-checkbox>
        <mat-checkbox class="reportCheckbox" [(ngModel)]="excelSelected"><span>Excel</span></mat-checkbox>
      </div>

      <div class="em-c-btn-group">
        <button class="em-c-btn em-c-btn--primary em-c-btn--small" (click)="SelectedExperiments(false)">
          <span class="em-c-btn__text">Generate Report</span>
        </button>
      </div>
    </div>
  </section>
  <div class="em-c-modal__overlay em-is-closed"></div>
</div>